import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import FacebookIcon from '@fabric-ds/icons/dist/24/facebook.svg';
import TwitterIcon from '@fabric-ds/icons/dist/24/twitter.svg';
import EmailIcon from '@fabric-ds/icons/dist/24/mail.svg';
import ShareIcon from '@fabric-ds/icons/dist/24/share.svg';
import CheckIcon from '@fabric-ds/icons/dist/16/check.svg';
import { trackClickOnShareAd } from 'common/lib/helpers/trackingService';
import { Button, Modal } from '@fabric-ds/react';

// eslint-disable-next-line react/prop-types
const SocialMediaButton = ({ url, icon, tracking }) => {
    return (
        <a href={url} className="button button--pill" onClick={() => tracking()}>
            {icon}
        </a>
    );
};

const SocialMedia = ({ heading, finnkode }) => {
    const iconSize = 24;
    const [open, setOpen] = useState(false);
    const [copy, setCopy] = useState(false);
    const shareFieldRef = useRef();
    const copyButton = useRef();

    const copyToClipboard = () => {
        shareFieldRef.current.select();
        document.execCommand('copy');
        trackClickOnShareAd();
        shareFieldRef.current.focus();
        setCopy(true);
    };

    const adUrl = `https://www.finn.no/${finnkode}`;
    const twitterUrl = `https://twitter.com/intent/tweet?hashtags&via=FINN_no&related=Finn_no&url=${encodeURIComponent(
        adUrl
    )}?taid=Share_ad_twitter&text=${encodeURIComponent(heading)}`;
    const faceBookurl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(adUrl)}`;
    const emailBody = `Jeg fant dette på finn.no: https://www.finn.no/${finnkode}`;
    const emailUrl = `mailto:?subject=${heading}&body=${emailBody}`;

    return (
        <div>
            <button
                type="button"
                className="button button--flat flex items-center"
                onClick={() => setOpen(true)}
                aria-label="Del"
            >
                <ShareIcon width={iconSize} height={iconSize} />
                <span className="hidden sm:block px-8 text-blue-600 whitespace-nowrap">Del</span>
            </button>
            <Modal open={open} right onDismiss={() => setOpen(false)} title="Del lenke">
                <input
                    onClick={event => event.target.select()}
                    className="w-full"
                    type="text"
                    value={adUrl}
                    readOnly
                    ref={shareFieldRef}
                />
                <div className="flex justify-between my-16">
                    <div className="flex">
                        <SocialMediaButton
                            url={emailUrl}
                            icon={<EmailIcon width={iconSize} height={iconSize} />}
                            tracking={() => trackClickOnShareAd('Email icon')}
                        />
                        <SocialMediaButton
                            url={faceBookurl}
                            icon={<FacebookIcon width={iconSize} height={iconSize} />}
                            tracking={() => trackClickOnShareAd('Facebook icon')}
                        />
                        <SocialMediaButton
                            url={twitterUrl}
                            icon={<TwitterIcon width={iconSize} height={iconSize} />}
                            tracking={() => trackClickOnShareAd('Twitter icon')}
                        />
                    </div>
                    <Button
                        primary
                        className="flex items-center"
                        onClick={copyToClipboard}
                        data-testid="copy-link-button"
                        aria-label={copy ? 'Kopiert' : 'Kopier lenke'}
                        ref={copyButton}
                    >
                        {copy ? (
                            <>
                                <span className="mr-8">Kopiert</span>
                                <CheckIcon />
                            </>
                        ) : (
                            'Kopier lenke'
                        )}
                    </Button>
                </div>
            </Modal>
        </div>
    );
};

SocialMedia.propTypes = {
    heading: PropTypes.string.isRequired,
    finnkode: PropTypes.number.isRequired,
};

export default SocialMedia;
